import React from 'react'
import ThemeToggle from '@shared/components/ThemeToggle'

export default function PublicNavbar() {
  return (
    <nav className="fixed top-0 left-0 right-0 bg-background border-b border-border shadow-sm z-20">
      <div className="h-16 px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        <div className="flex items-center">
          <h1 className="text-2xl font-bold text-primary">Motiv Admin</h1>
        </div>
        <div className="flex items-center gap-3">
          <ThemeToggle />
        </div>
      </div>
    </nav>
  )
}
